import { useMutation, useQueryClient } from "@tanstack/react-query";
import { makeApiRequest } from "../../utils";
import { SPENDING_AGGREGATIONS_QUERY_KEY } from "../../../constants/queryKeys";

export const useCreateSpendingAggregation = () => {
  const queryClient = useQueryClient();

  const createSpendingAggregation = useMutation({
    mutationFn: async ({ data }) => {
      return makeApiRequest({
        endpoint: "/api/spendingAggregations",
        method: "POST",
        body: data,
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([SPENDING_AGGREGATIONS_QUERY_KEY]);
    }
  });

  return { createSpendingAggregation };
};

export const useUpdateSpendingAggregation = () => {
  const queryClient = useQueryClient();

  const updateSpendingAggregation = useMutation({
    mutationFn: async ({ id, data }) => {
      return makeApiRequest({
        endpoint: `/api/spendingAggregations/${id}`,
        method: "PUT",
        body: data,
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([SPENDING_AGGREGATIONS_QUERY_KEY]);
    }
  });

  return { updateSpendingAggregation };
};

export const useArchiveSpendingAggregation = () => {
  const queryClient = useQueryClient();

  const archiveSpendingAggregation = useMutation({
    mutationFn: async ({ id }) => {
      return makeApiRequest({
        endpoint: `/api/spendingAggregations/${id}/archive`,
        method: "PUT",
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([SPENDING_AGGREGATIONS_QUERY_KEY]);
    }
  });

  return { archiveSpendingAggregation };
};

export const useRestoreSpendingAggregation = () => {
  const queryClient = useQueryClient();

  const restoreSpendingAggregation = useMutation({
    mutationFn: async ({ id }) => {
      return makeApiRequest({
        endpoint: `/api/spendingAggregations/${id}/restore`,
        method: "PUT",
        json: true
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries([SPENDING_AGGREGATIONS_QUERY_KEY]);
    }
  });

  return { restoreSpendingAggregation };
};

export const usePreviewSpendingAggregationVendors = () => {
  const previewVendors = useMutation({
    mutationFn: async ({ criteria }) => {
      return makeApiRequest({
        endpoint: "/api/spendingAggregations/preview-vendors",
        method: "POST",
        body: { criteria },
        json: true
      });
    }
  });

  return { previewVendors };
};
